module.exports = __webpack_public_path__ + "img/logo.7f6385d9.png";